/** Moeda de vaga, projeto e proposta. O valor fica na unidade da coluna, sem conversão. */
export enum Moeda {
  BRL = "BRL",
  USD = "USD",
}

/** Na ordem das opções de um campo de moeda: R$ sempre primeiro. */
export const MOEDAS: readonly { value: Moeda; label: string }[] = [
  { value: Moeda.BRL, label: "R$" },
  { value: Moeda.USD, label: "US$" },
];

/** O que vem do banco. Valor ausente ou desconhecido é real: era tudo real antes de existir a coluna. */
export function parseMoeda(value: string | null | undefined): Moeda {
  return value === Moeda.USD ? Moeda.USD : Moeda.BRL;
}

export function simboloMoeda(moeda: Moeda): string {
  return moeda === Moeda.USD ? "US$" : "R$";
}

const BRL_FORMATTER = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
const USD_FORMATTER = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "USD" });

/** Formata um valor em CENTAVOS (padrão de armazenamento do módulo financeiro) para BRL. */
export function formatCentsBRL(cents: number | null | undefined): string {
  if (cents == null) return "-";
  return BRL_FORMATTER.format(cents / 100);
}

/** Centavos na moeda da vaga, projeto ou proposta. */
export function formatCents(cents: number | null | undefined, moeda: Moeda = Moeda.BRL): string {
  if (cents == null) return "-";
  return (moeda === Moeda.USD ? USD_FORMATTER : BRL_FORMATTER).format(cents / 100);
}

/**
 * Converte um valor digitado em reais para centavos inteiros. Aceita "1.500,50",
 * "1500,50", "1500.50", "R$ 1.500" e "US$ 1.500": ponto só é decimal quando é o único
 * separador e tem 1 ou 2 casas depois dele.
 */
export function parseReaisToCents(value: string): number | null {
  let normalizado = value.trim().replace(/[RUS$\s]/g, "");
  if (normalizado === "") return null;
  if (normalizado.includes(",")) {
    normalizado = normalizado.replace(/\./g, "").replace(",", ".");
  } else if (!/^\d+\.\d{1,2}$/.test(normalizado)) {
    normalizado = normalizado.replace(/\./g, "");
  }
  const reais = Number(normalizado);
  if (!Number.isFinite(reais) || reais < 0) return null;
  return Math.round(reais * 100);
}

/** Centavos para o texto de um input em reais ("1500,50"). */
export function centsToReaisInput(cents: number | null | undefined): string {
  if (cents == null) return "";
  return (cents / 100).toFixed(2).replace(".", ",");
}

/** "10", "12,5": percentual pt-BR sem zeros à direita. */
export function formatPercent(value: number): string {
  return value.toLocaleString("pt-BR", { maximumFractionDigits: 2 });
}
